import { render, staticRenderFns } from "./modify-message-template.vue?vue&type=template&id=33404c80&scoped=true"
import script from "./modify-message-template.vue?vue&type=script&lang=ts"
export * from "./modify-message-template.vue?vue&type=script&lang=ts"
import style0 from "./modify-message-template.vue?vue&type=style&index=0&id=33404c80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33404c80",
  null
  
)

export default component.exports